import { render, staticRenderFns } from "./sliderEvent.vue?vue&type=template&id=244db4ff&scoped=true&xmlns%3Av-swiper=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./sliderEvent.vue?vue&type=script&lang=js&"
export * from "./sliderEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244db4ff",
  null
  
)

export default component.exports